import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import React, { useEffect, useRef } from "react";
import {
  StyleSheet,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native";
import Svg, { Circle, Path } from "react-native-svg";
import {
  authLogin,
  resendOtp,
  setUserId,
  verifyOtp,
  googleSignIn,
  appleSignIn,
} from "appRedux/reducers/authSlice";
import { fp, hp, spH, spV, wp } from "utils/normalise";
import { useDispatch, useSelector } from "react-redux";

import BottomSheetModal from "./BottomSheetModal";
import Buttons from "./Buttons";
import CodeField from "./CodeField";
import { Colors } from "colors";
import ImageView from "../../src/image";
import { Images } from "assets";
import { Svg as Svgs } from "assets/svg";
import Input from "./Input";
import { REGEX } from "utils/Constants";
import VText from "./VText";
import { router } from "expo-router";
import { setGuestUserId } from "appRedux/reducers/storedUtilsSlice";
import { showSuccess } from "utils/ToastUtils";
import { useState } from "react";
import { AsyncStorageKeys } from "utils/enum";
import AsyncStorage from "@react-native-async-storage/async-storage";
import GoogleAuth from "./auth/googleSignButtonCop";
import AppleAuth from "./auth/appleSignButtonCop";
import {
  getCountry,
  setCountry,
  setCurrency,
  setCountries,
} from "appRedux/reducers/storedUtilsSlice";
import {
  updateUserProfile,
  getUserDetails,
} from "appRedux/reducers/profileSlice";

export default React.forwardRef((props, ref) => {
  const [email, setEmail] = useState("");
  const [isEmailError, setIsEmailError] = useState(false);
  const [isInvalidOtp, setIsInvalidOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [expireTimer, setExpireTimer] = useState(0);
  const [resendLoading, setResendLoading] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [isGuest, setIsGuest] = useState(false);
  const [showGuesOptions, setShowGuesOptions] = useState(true);
  const countries = useSelector((state) => state.StoredutilsSlice.countries);
  const _countryModalRef = useSelector(
    (state) => state.UtilsReducer._countryModalRef
  );

  const guestUserId = useSelector(
    (state) => state.StoredutilsSlice.guestUserId
  );

  const dispatch = useDispatch();

  const { height, width } = useWindowDimensions();
  const _bottomSheetRef = useRef();

  const translateLogin = useSharedValue(0);
  const translateOtp = useSharedValue(wp(450));

  React.useImperativeHandle(
    ref,
    () => ({
      show,
    }),
    []
  );

  useEffect(() => {
    let resendID;
    if (resendTimer > 0) {
      resendID = setTimeout(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearTimeout(resendID);
  }, [resendTimer]);

  useEffect(() => {
    let expireID;
    if (expireTimer > 0) {
      expireID = setTimeout(() => {
        setExpireTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => clearTimeout(expireID);
  }, [expireTimer]);

  const show = (showGuesOptions = false) => {
    setShowGuesOptions(showGuesOptions);
    _bottomSheetRef?.current?.show();
    setIsInvalidOtp(false);
    setOtp(["", "", "", ""]);
    setEmail("");
    translateLogin.value = withTiming(0);
    translateOtp.value = withTiming(wp(450));
    setLoading(false);
    setResendLoading(false);
    setIsGuest(false);
  };

  const loginAnimatedStyles = useAnimatedStyle(() => ({
    transform: [{ translateX: translateLogin.value }],
  }));

  const otpAnimatedStyles = useAnimatedStyle(() => ({
    transform: [{ translateX: translateOtp.value }],
  }));

  const onLogin = async () => {
    setLoading(true);
    dispatch(
      authLogin({
        emailId: email?.trim()?.toLowerCase(),
        status: 1,
        type: "client",
        isGuest: isGuest,
        guestUserId: guestUserId,
      })
    )
      .then((res) => {
        setLoading(false);
        if ([200].includes(res?.payload?.data?.data?.statusCode)) {
          if (isGuest) {
            if (
              res?.payload?.data?.data?.statusMessage ==
              "Guest user created successfully"
            ) {
              dispatch(setUserId(res?.payload?.data?.data?.userId));
              dispatch(setGuestUserId(res?.payload?.data?.data?.userId));
              _bottomSheetRef?.current?.hide();
              router.navigate("/add-address?isGuest=true");
            } else if (
              res?.payload?.data?.data?.statusMessage == "OTP sent successfully"
            ) {
              translateLogin.value = withTiming(-wp(450));
              translateOtp.value = withTiming(0);
              setResendTimer(60);
              setExpireTimer(60 * 5);
              setIsInvalidOtp(false);
              setOtp(["", "", "", ""]);
            } else {
              alert("Error");
            }
          } else {
            translateLogin.value = withTiming(-wp(450));
            translateOtp.value = withTiming(0);
            setResendTimer(60);
            setExpireTimer(60 * 5);
            setIsInvalidOtp(false);
            setOtp(["", "", "", ""]);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
      });
  };

  const sendOtpAgain = () => {
    setResendLoading(true);
    dispatch(
      resendOtp({
        emailId: email,
        status: 1,
      })
    )
      .then((res) => {
        setResendLoading(false);
        if ([200].includes(res?.payload?.status)) {
          setResendTimer(60);
          setExpireTimer(60 * 5);
          setIsInvalidOtp(false);
          setOtp(["", "", "", ""]);
        } else {
          // SimpleToast.show(t('Global.error'));
        }
      })
      .catch((err) => {
        setResendLoading(false);
        console.log("err", err);
      });
  };

  const onPressVerify = () => {
    setLoading(true);
    dispatch(
      verifyOtp({
        emailId: email,
        otp: otp?.join("")?.trim(),
        status: 1,
        type: "client",
        guestUserId: guestUserId,
      })
    )
      .then(async (res) => {
        if ([200].includes(res?.payload?.data?.data?.statusCode)) {
          dispatch(setUserId(res?.payload?.data?.data?.userId));
          dispatch(setGuestUserId(res?.payload?.data?.data?.userId));
          fetchUserProfile();

          await AsyncStorage.setItem(
            AsyncStorageKeys.USER_ID,
            res?.payload?.data?.data?.userId
          );
          await AsyncStorage.setItem(
            AsyncStorageKeys.SESSION_ID,
            res?.payload?.data?.data?.sessionId
          );
          showSuccess("Logged In Successfully!");
          _bottomSheetRef?.current?.hide();
          if (res?.payload?.data?.data?.isProfileCreated == false) {
            router.navigate("/create-profile");
          }
        } else {
          setLoading(false);
          alert(res?.payload?.data?.data?.statusMessage);
        }
      })
      .catch((err) => {
        setLoading(false);
        alert("Something went wrong");
      });
  };

  const handleGoogleSignIn = (response) => {
    let data = {
      accessToken: response.access_token,
    };
    dispatch(googleSignIn(data))
      .then(async (res) => {
        if ([200].includes(res?.payload?.data?.data?.statusCode)) {
          dispatch(setUserId(res?.payload?.data?.data?.userId));
          dispatch(setGuestUserId(res?.payload?.data?.data?.userId));
          await AsyncStorage.setItem(
            AsyncStorageKeys.USER_ID,
            res?.payload?.data?.data?.userId
          );
          await AsyncStorage.setItem(
            AsyncStorageKeys.SESSION_ID,
            res?.payload?.data?.data?.sessionId
          );
          showSuccess("Logged In Successfully!");
          fetchUserProfile();
          _bottomSheetRef?.current?.hide();
          if (res?.payload?.data?.data?.isProfileCreated == false) {
            router.navigate("/create-profile");
          }
        } else {
          setLoading(false);
          alert(res?.payload?.data?.data?.statusMessage);
          _bottomSheetRef?.current?.hide();
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
      });
  };

  const handleAppleSignIn = (response) => {
    let data = {
      identityToken: response?.authorization?.id_token,
    };
    dispatch(appleSignIn(data))
      .then(async (res) => {
        if ([200].includes(res?.payload?.data?.data?.statusCode)) {
          dispatch(setUserId(res?.payload?.data?.data?.userId));
          dispatch(setGuestUserId(res?.payload?.data?.data?.userId));

          await AsyncStorage.setItem(
            AsyncStorageKeys.USER_ID,
            res?.payload?.data?.data?.userId
          );
          await AsyncStorage.setItem(
            AsyncStorageKeys.SESSION_ID,
            res?.payload?.data?.data?.sessionId
          );
          fetchUserProfile();
          showSuccess("Logged In Successfully!");
          _bottomSheetRef?.current?.hide();
          if (res?.payload?.data?.data?.isProfileCreated == false) {
            router.navigate("/create-profile");
          }
        } else {
          setLoading(false);
          alert(res?.payload?.data?.data?.statusMessage);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
        alert("Something went wrong");
      });
  };

  const fetchUserProfile = () => {
    dispatch(getUserDetails())
      .then((res) => {
        if (res?.payload?.data?.data) {
          const userProfile = res?.payload?.data?.data;
          const defaultCountry =
            userProfile?.lastUsedCountry || "United States of America";
          const defaultCurrency = userProfile?.lastUsedCurrency || "USD";
          const countryDetails =
            countries.find((item) => item.name === defaultCountry) || {};

          const country = {
            name: countryDetails.name,
            imageUrl: countryDetails.imageUrl,
            currency: defaultCurrency,
          };

          dispatch(setCountry(country));
          dispatch(setCurrency(defaultCurrency));

          dispatch(getCountry())
            .then((res) => {
              if (res?.payload?.data?.data?.allCountries) {
                let IPBasedCountry = res?.payload?.data?.data?.country;

                if (IPBasedCountry != userProfile?.lastUsedCountry) {
                  if (_countryModalRef) {
                    _countryModalRef?.current?.show();
                  }
                }
              }
            })
            .catch((err) => {});
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <BottomSheetModal
      MAX_HEIGHT_PERC={1}
      START_PERC={1}
      ref={_bottomSheetRef}
      hideLine
      containerStyle={{
        backgroundColor: "transparent",
        zIndex: 100,
      }}
    >
      <TouchableOpacity
        style={{
          backgroundColor: "transparent",
          width,
          height,
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          zIndex: 100,
          cursor: "auto",
        }}
        activeOpacity={1}
        onPress={() => _bottomSheetRef?.current?.hide()}
      >
        <TouchableOpacity
          style={{
            width: wp(782),
            height: hp(549),
            backgroundColor: "#fff",
            paddingVertical: spV(44),
            paddingHorizontal: spV(44),
            overflow: "hidden",
            cursor: "auto",
          }}
          activeOpacity={1}
        >
          <TouchableOpacity
            onPress={() => _bottomSheetRef?.current?.hide()}
            activeOpacity={0.8}
            style={{
              position: "absolute",
              right: 20,
              top: 20,
            }}
          >
            <Svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <Circle cx="12" cy="12" r="12" fill="#F7F7F7" />
              <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.4693 12.0006L7.75684 15.713L8.28717 16.2433L11.9996 12.5309L15.712 16.2433L16.2423 15.713L12.5299 12.0006L16.2423 8.28814L15.712 7.75781L11.9996 11.4702L8.28717 7.75781L7.75684 8.28814L11.4693 12.0006Z"
                fill="#212427"
              />
            </Svg>
          </TouchableOpacity>
          <View
            style={{
              backgroundColor: "white",
              flexDirection: "row",
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            <View
              style={{
                width: wp(309),
              }}
            >
              <View style={styles.container}>
                <ImageView
                  source={Images.banner1}
                  resizeMode={ImageView.resizeMode.contain}
                  style={{
                    height: hp(199),
                    width: wp(309),
                  }}
                />
              </View>
              <View
                style={{
                  paddingVertical: hp(8),
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Svg
                  width="84"
                  height="31"
                  viewBox="0 0 84 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <Path
                    d="M0.507812 8.71094H6.75781L11.1914 24.4141L15.7227 8.71094H21.6992L14.0234 30H8.14453L0.507812 8.71094ZM43.0859 23.75C42.9427 25.013 42.2852 26.2956 41.1133 27.5977C39.2904 29.668 36.7383 30.7031 33.457 30.7031C30.7487 30.7031 28.3594 29.8307 26.2891 28.0859C24.2188 26.3411 23.1836 23.5026 23.1836 19.5703C23.1836 15.8854 24.1146 13.0599 25.9766 11.0938C27.8516 9.1276 30.2799 8.14453 33.2617 8.14453C35.0326 8.14453 36.6276 8.47656 38.0469 9.14062C39.4661 9.80469 40.638 10.8529 41.5625 12.2852C42.3958 13.5482 42.9362 15.013 43.1836 16.6797C43.3268 17.6562 43.3854 19.0625 43.3594 20.8984H28.7891C28.8672 23.0339 29.5378 24.5312 30.8008 25.3906C31.569 25.9245 32.4935 26.1914 33.5742 26.1914C34.7201 26.1914 35.651 25.8659 36.3672 25.2148C36.7578 24.8633 37.1029 24.375 37.4023 23.75H43.0859ZM37.5781 17.2266C37.487 15.7552 37.0378 14.6419 36.2305 13.8867C35.4362 13.1185 34.4466 12.7344 33.2617 12.7344C31.9727 12.7344 30.9701 13.138 30.2539 13.9453C29.5508 14.7526 29.1081 15.8464 28.9258 17.2266H37.5781ZM31.1523 0H36.1523L40.7227 5.83984H36.1914L33.6523 2.55859L31.0938 5.83984H26.5625L31.1523 0ZM56.875 26.0352V30.1953L54.2383 30.293C51.6081 30.3841 49.8112 29.9284 48.8477 28.9258C48.2227 28.2878 47.9102 27.3047 47.9102 25.9766V12.8711H44.9414V8.90625H47.9102V2.96875H53.418V8.90625H56.875V12.8711H53.418V24.1211C53.418 24.9935 53.5286 25.5404 53.75 25.7617C53.9714 25.9701 54.6484 26.0742 55.7812 26.0742C55.9505 26.0742 56.1263 26.0742 56.3086 26.0742C56.5039 26.0612 56.6927 26.0482 56.875 26.0352ZM66.1719 8.71094V30H60.5273V8.71094H66.1719ZM66.1719 1.03516V6.17188H60.5273V1.03516H66.1719ZM82.2852 13.8477C80.0456 13.8477 78.5417 14.5768 77.7734 16.0352C77.3438 16.8555 77.1289 18.1185 77.1289 19.8242V30H71.5234V8.71094H76.8359V12.4219C77.6953 11.0026 78.444 10.0326 79.082 9.51172C80.1237 8.63932 81.4779 8.20312 83.1445 8.20312C83.2487 8.20312 83.3333 8.20964 83.3984 8.22266C83.4766 8.22266 83.6393 8.22917 83.8867 8.24219V13.9453C83.5352 13.9062 83.2227 13.8802 82.9492 13.8672C82.6758 13.8542 82.4544 13.8477 82.2852 13.8477Z"
                    fill="black"
                  />
                </Svg>
              </View>

              <View style={styles.container}>
                <ImageView
                  source={Images.banner2}
                  resizeMode={ImageView.resizeMode.contain}
                  style={{
                    width: wp(311),
                    height: hp(200),
                  }}
                />
              </View>
            </View>
            <View
              style={{
                overflow: "hidden",
                flex: 1,
                height: hp(462),
                width: wp(343),
                paddingRight: spH(10),
              }}
            >
              <Animated.View
                style={[
                  {
                    position: "absolute",
                    left: 0,
                    top: 0,
                  },
                  loginAnimatedStyles,
                ]}
              >
                <View
                  style={{
                    marginLeft: spH(48),
                    width: wp(333),
                    height: hp(462),
                    justifyContent: "center",
                  }}
                >
                  <VText
                    style={{
                      padding: spH(8),
                      fontWeight: "550",
                      fontSize: fp(20),
                      textAlign: "center",
                      color: "#212427",
                      fontFamily: "JosefinSans",
                    }}
                  >
                    {isGuest ? "Guest Checkout" : "Login or Signup"}
                  </VText>
                  <Input
                    propStyle={{
                      borderRadius: 0,
                      width: "100%",
                      color: isEmailError ? "#CE1A1A" : "#212427",
                      fontSize: fp(16),
                      outlineStyle: "none",
                      fontWeight: "350",
                    }}
                    showIcon
                    leftIcon={() => (
                      <View
                        style={{
                          paddingRight: spH(16),
                        }}
                      >
                        <Svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <Path
                            d="M11.9991 11.6075L21.5841 5.45C21.1987 5.16096 20.7308 5.00323 20.2491 5H3.74906C3.26736 5.00323 2.79942 5.16096 2.41406 5.45L11.9991 11.6075Z"
                            fill={isEmailError ? "#CE1A1A" : "#212427"}
                            fillOpacity={email?.length > 0 ? "1" : "0.3"}
                          />
                          <Path
                            d="M12.405 13.1303L12.2775 13.1903H12.2175C12.1484 13.2212 12.0751 13.2414 12 13.2503V13.2503C11.9377 13.2582 11.8748 13.2582 11.8125 13.2503H11.7525L11.625 13.1903L1.575 6.69531C1.52698 6.87647 1.50179 7.06291 1.5 7.25031V17.7503C1.5 18.347 1.73705 18.9193 2.15901 19.3413C2.58097 19.7633 3.15326 20.0003 3.75 20.0003H20.25C20.8467 20.0003 21.419 19.7633 21.841 19.3413C22.2629 18.9193 22.5 18.347 22.5 17.7503V7.25031C22.4982 7.06291 22.473 6.87647 22.425 6.69531L12.405 13.1303Z"
                            fill={isEmailError ? "#CE1A1A" : "#212427"}
                            fillOpacity={email?.length > 0 ? "1" : "0.3"}
                          />
                        </Svg>
                      </View>
                    )}
                    inputContainerStyle={{
                      height: hp(44),
                      paddingVertical: 8,
                      borderColor:
                        email?.length > 0
                          ? isEmailError
                            ? "#CE1A1A"
                            : "#000000"
                          : "#0000004D",
                    }}
                    containerStyle={{
                      height: hp(44),
                    }}
                    placeholder={"Email"}
                    value={email}
                    onChangeText={(txt) => {
                      setEmail(txt?.trim());
                      setIsEmailError(false);
                    }}
                  />
                  {isEmailError && (
                    <VText
                      style={{
                        color: "#CE1A1A",
                        fontFamily: "JosefinSans",
                        paddingTop: spV(8),
                        textAlign: "right",
                      }}
                      text="Enter a valid email address"
                    />
                  )}
                  <Buttons
                    containerStyle={{
                      backgroundColor: REGEX.email.test(email)
                        ? "#212427"
                        : "#2124274D",
                      borderRadius: 0,
                      marginTop: spV(16),
                      paddingVertical: spV(16),
                      paddingHorizontal: spH(16),
                      height: hp(44),
                    }}
                    loading={loading}
                    onPress={() => {
                      if (REGEX.email.test(email)) {
                        onLogin();
                      } else {
                        setIsEmailError(true);
                      }
                    }}
                    textStyle={{
                      fontSize: fp(16),
                      fontWeight: "350",
                    }}
                    text={isGuest ? "Continue As Guest" : "Continue"}
                  />

                  <View
                    style={{
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <VText
                      style={{
                        fontSize: fp(14),
                        fontWeight: "700",
                        marginVertical: spV(12),
                      }}
                      text="Or "
                    />
                    <View
                      style={{
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: spV(12),
                      }}
                    >
                      <GoogleAuth onSuccess={handleGoogleSignIn} />
                      <AppleAuth onSuccess={handleAppleSignIn} />

                      {showGuesOptions && (
                        <Buttons
                          containerStyle={{
                            borderRadius: 4,
                            // marginTop: spV(8),
                            paddingHorizontal: spH(16),
                            paddingVertical: spV(16),
                            borderWidth: 1,
                            height: hp(44),
                            borderColor: "#E6E8E7",
                            width: wp(335),
                          }}
                          textStyle={{
                            color: "#212427",
                            fontSize: "14px",
                            fontWeight: "600",
                            fontFamily: "JosefinSans",
                          }}
                          isInverse
                          onPress={() => {
                            setIsGuest((prev) => !prev);
                          }}
                          text={isGuest ? "Login" : "Continue As Guest"}
                        />
                      )}
                    </View>
                  </View>
                </View>
              </Animated.View>

              <Animated.View
                style={[
                  {
                    position: "absolute",
                  },
                  otpAnimatedStyles,
                ]}
              >
                <View
                  style={{
                    marginLeft: spH(28),
                    width: wp(333),
                    height: hp(462),
                    justifyContent: "center",
                  }}
                >
                  <VText
                    style={{
                      padding: spH(8),
                      fontWeight: "550",
                      fontSize: fp(20),
                      textAlign: "center",
                      color: "#212427",
                      fontFamily: "JosefinSans",
                    }}
                  >
                    Verify Your Email
                  </VText>
                  <VText
                    style={{
                      padding: spH(8),
                      fontWeight: "350",
                      fontSize: fp(16),
                      textAlign: "center",
                      color: "#21242799",
                      fontFamily: "JosefinSans",
                      paddingTop: 0,
                    }}
                  >
                    {isGuest
                      ? `Account already exists. We have sent you a 4 digit OTP to your given email`
                      : `We have sent you a 4 digit OTP to your given email`}
                    <VText
                      style={{
                        padding: spH(8),
                        fontWeight: "350",
                        fontSize: fp(16),
                        textAlign: "center",
                        color: "#212427",
                        fontFamily: "JosefinSans",
                      }}
                    >
                      {email}
                    </VText>
                  </VText>
                  <View
                    style={{
                      paddingTop: spV(12),
                    }}
                  >
                    <CodeField
                      otp={otp}
                      setOtp={(data) => {
                        setOtp(data);
                        setIsInvalidOtp(false);
                      }}
                      isError={isInvalidOtp}
                    />
                  </View>
                  {!isEmailError && (
                    <VText
                      style={{
                        color: isInvalidOtp ? "#CE1A1A" : "#21242799",
                        fontFamily: "JosefinSans",
                        paddingTop: spV(8),
                        textAlign: "right",
                        fontSize: fp(12),
                        paddingBottom: spV(20),
                      }}
                      text={
                        !isInvalidOtp
                          ? `OTP will be expired after ${String(
                              Math.floor(expireTimer / 60)
                            ).padStart(2, 0)}:${String(
                              expireTimer % 60
                            ).padStart(2, 0)}`
                          : "Enter a valid OTP"
                      }
                    />
                  )}

                  {isEmailError && (
                    <VText
                      style={{
                        color: "#CE1A1A",
                        fontFamily: "JosefinSans",
                        paddingTop: spV(8),
                        textAlign: "right",
                      }}
                      text="Enter a valid email address"
                    />
                  )}
                  <Buttons
                    containerStyle={{
                      backgroundColor:
                        otp?.join("")?.length == 4 ? "#212427" : "#2124274D",
                      borderRadius: 0,
                      paddingHorizontal: spH(16),
                      paddingVertical: spV(16),
                      height: hp(44),
                    }}
                    textStyle={{
                      fontWeight: "350",
                      fontSize: fp(16),
                    }}
                    disabled={otp?.join("")?.length != 4}
                    loading={loading}
                    onPress={onPressVerify}
                    text={"Verify"}
                  />
                  <Buttons
                    containerStyle={{
                      borderRadius: 0,
                      marginTop: spV(8),
                      paddingHorizontal: spH(16),
                      paddingVertical: spV(16),
                    }}
                    textStyle={{
                      color: resendTimer > 0 ? "#2124274D" : "#212427",
                      fontWeight: "550",
                    }}
                    isInverse
                    loading={resendLoading}
                    onPress={sendOtpAgain}
                    disabled={resendTimer > 0}
                    text={
                      resendTimer > 0
                        ? `Send OTP again in ${resendTimer} secs`
                        : "Send OTP again"
                    }
                  />
                  <Buttons
                    containerStyle={{
                      borderRadius: 0,
                      paddingHorizontal: spH(16),
                      borderWidth: 0,
                      padding: 0,
                      paddingTop: 8,
                    }}
                    textStyle={{
                      color: "#212427",
                    }}
                    isInverse
                    onPress={() => {
                      translateLogin.value = withTiming(0);
                      translateOtp.value = withTiming(wp(450));
                      if (REGEX.email.test(email)) {
                      } else {
                        setIsEmailError(true);
                      }
                    }}
                    text={"Change Email"}
                  />
                </View>
              </Animated.View>
            </View>
          </View>
        </TouchableOpacity>
      </TouchableOpacity>
    </BottomSheetModal>
  );
});

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
    borderRadius: 8,
    width: wp(309),
  },
  image: {
    width: wp(309),
    height: hp(199),
  },
});
